import EventEmitter from "event-emitter-es6";

export default class API extends EventEmitter {

  constructor(axios) {
    super();
    this.axios = axios
  }
}
